import { toast } from "sonner";

/**
 * Universal handler for 402 (Payment Required = plan-limit exceeded).
 * Pass an axios error or a Response. Returns true if it was a plan-limit error.
 */
export function handlePlanLimit(err) {
  const status = err?.response?.status;
  if (status !== 402) return false;
  const detail = err.response?.data?.detail || "Plan limit reached.";
  const kind = err.response?.headers?.["x-plan-limit-kind"] || "";
  toast.error(detail, {
    description: kind ? `Quota: ${kind}` : undefined,
    action: { label: "Upgrade", onClick: () => { window.location.href = "/pricing"; } },
    duration: 8000,
  });
  return true;
}
